import React from 'react';
import CandidateItem from './CandidateItem';
const CandidateList = ({
    data,
    handleChangeDropdown,
    handleInputChange,
    handleDelete,
    refreshData,
    setPopupSendMailOpen,
    setReceiver,
    getListData,
    payload,
    handleSave,
}) => {
    return (
        <>
            {data && data.length > 0 ? (
                data.map((item, index) => {
                    return (
                        <CandidateItem
                            item={item}
                            handleChangeDropdown={handleChangeDropdown}
                            handleInputChange={handleInputChange}
                            handleDelete={handleDelete}
                            refreshData={refreshData}
                            setPopupSendMailOpen={setPopupSendMailOpen}
                            setReceiver={setReceiver}
                            getListData={getListData}
                            payload={payload}
                            handleSave={handleSave}
                            key={index}
                        />
                    );
                })
            ) : (
                <div className="no-data" style={{ backgroundColor: '#fff', marginTop: '20px' }}>
                    데이터없습니다
                </div>
            )}
        </>
    );
};

export default CandidateList;
